import GTMService from "../services/GTMService";
import store from "../store/store";
import enumScreenView from "./enumScreenView";
import enumInteraction from "./enumInteraction";
import enumNonInteraction from "./enumNonInteraction";


export default class{

    static dispatchScreenView(tag, history)
    {
        this.$store = store;
        let jornada = this.$store.getters.isJornadaCompleta;

        let fluxo = this.$store.getters.origemProcesso;
        let pageName = jornada == true ? jornada = enumScreenView.screenViewDoc[`${tag}`] : jornada = enumScreenView.screenViewSelfieOnly[`${tag}`];
        if(history) {
            history = '/biometry-'+fluxo+history;
        }

        GTMService.dispatchScreenView(fluxo,`${pageName}`,history);
    }

    static dispatchDynamicScreenView(tag)
    {
        this.$store = store;
        let jornada = this.$store.getters.isJornadaCompleta;
        let fluxo = jornada.fluxo == false ? "" : this.$store.getters.origemProcesso;

        GTMService.dispatchScreenView(fluxo,tag);
    }

    static dispatchInraction(tag)
    {
        this.$store = store;
        let jornada = this.$store.getters.isJornadaCompleta;

        jornada == true ? jornada = enumInteraction.InteractionDoc[`${tag}`] : jornada = enumInteraction.InteractionSelfieOnly[`${tag}`];

        let lb = jornada.lb;
        let type = jornada.type;
        let fluxo = this.$store.getters.origemProcesso;
        GTMService.dispatchInraction(lb,type,fluxo);

    }

    static dispatchNoninteraction(tag)
    {
        this.$store = store;
        let jornada = this.$store.getters.isJornadaCompleta;


        jornada == true ? jornada = enumNonInteraction.NonInteractionDoc[`${tag}`] : jornada = enumNonInteraction.NonInteractionSelfieOnly[`${tag}`];

        let lb = jornada.lb;
        let ac = jornada.ac;
        let fluxo = jornada.fluxo == false ? "" : this.$store.getters.origemProcesso;
        GTMService.dispatchNoninteraction(lb,ac,fluxo);

    }

    static dispatchDynamicNoninteraction(lb)
    {
        this.$store = store;
        let jornada = this.$store.getters.isJornadaCompleta;
        let fluxo = jornada.fluxo == false ? "" : this.$store.getters.origemProcesso;

        GTMService.dispatchNoninteraction(lb,null,fluxo);

    }
}



// WEBPACK FOOTER //
// ./src/utils/DispatchTags.js